/**
 * A method that sets up the routes for this module
 */
export const initialise = () => {
  angular.module('app.settlement-period').config(['$stateProvider', '$urlRouterProvider', '$locationProvider', ($stateProvider, $urlRouterProvider, $locationProvider) => {
    $locationProvider.hashPrefix('');

    $stateProvider.state('settlement-period', {
      url: '/settlement-period',
      templateUrl: 'app/angularJS/features/abt/settlement-period/settlement-period.html',
      controller: 'settlementPeriodController',
      controllerAs: 'vm',
      parent: 'common'
    });

    $urlRouterProvider.otherwise('/');
  }]);
};